import { FormEvent, useState } from 'react';
import { Box, Button, Card, CardContent, Container, Stack, TextField, Typography } from '@mui/material';

import type { ContactBlockContent } from '@/types/database';

export function ContactBlockView({ content }: { content: ContactBlockContent }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
    }, 1000);
  };

  return (
    <Box sx={{ py: 6 }}>
      <Container maxWidth="sm">
        {content.heading ? (
          <Typography variant="h4" sx={{ fontWeight: 700, textAlign: "center", mb: 1 }}>
            {content.heading}
          </Typography>
        ) : null}
        {content.description ? (
          <Typography color="text.secondary" sx={{ textAlign: "center", mb: 3 }}>
            {content.description}
          </Typography>
        ) : null}

        {isSubmitted ? (
          <Card variant="outlined" role="status">
            <CardContent sx={{ py: 5, textAlign: 'center' }}>
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>Message Sent</Typography>
              <Typography color="text.secondary">Thank you for reaching out. We&apos;ll get back to you soon.</Typography>
            </CardContent>
          </Card>
        ) : (
          <Card variant="outlined">
            <CardContent>
              <Stack component="form" spacing={2} onSubmit={handleSubmit}>
                {content.showName !== false ? <TextField label="Name" required fullWidth /> : null}
                {content.showEmail !== false ? <TextField label="Email" type="email" required fullWidth /> : null}
                {content.showMessage !== false ? <TextField label="Message" multiline rows={4} required fullWidth /> : null}
                <Button type="submit" variant="contained" disabled={isSubmitting}>
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </Button>
              </Stack>
            </CardContent>
          </Card>
        )}
      </Container>
    </Box>
  );
}
